import React, { useEffect } from 'react';
import { getAgentResponse, getAgentResponseText, onTriggerAutoNavUrl, paintNavUrl } from '../../../AlmeResponse/AlmeResponse';
import { AgentCardContainer, AgentCardMessageContainer, AgentCardBubbleContent } from '../../../AlmeResponse/AlmeResponse.styles';
import { AgentCardBubble } from '../../../AlmeResponse/ChatBubble';
import OperatorIcon from '../../../AlmeUtilities/Icons/OperatorIcon';
export function isValidLiveChatOperatorResponse(response) {
    var _a, _b, _c;
    const responseText = getAgentResponseText(response);
    const hasIvaResponse = !!(responseText || response.navUrl || ((_b = (_a = response.displayLinkCollection) === null || _a === void 0 ? void 0 : _a.Sections) === null || _b === void 0 ? void 0 : _b.length));
    return hasIvaResponse && ((_c = response === null || response === void 0 ? void 0 : response.extensionData) === null || _c === void 0 ? void 0 : _c.MessageOrigin) === 'Operator';
}
const AlmeLiveChatOperatorResponse = (props) => {
    var _a;
    const response = Object.assign(Object.assign({}, props.response), { html: '' });
    useEffect(() => {
        if (response.navUrl && props.appConfig.liveChatOperatorResponse.shouldAutoNav) {
            onTriggerAutoNavUrl(response.navUrl, props.appConfig, props.onDisplayLinkClick);
        }
        // Empty dependency-list so autoNav only happens once:
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!isValidLiveChatOperatorResponse(props.response)) {
        return null;
    }
    const responseRevision = (props.responseId || response.responseRevision).toString();
    const entryId = response.extensionData.entryId || responseRevision;
    const operatorName = (_a = props.response.extensionData.OperatorData) === null || _a === void 0 ? void 0 : _a.Name;
    const operatorFirstLetter = operatorName ? operatorName[0] : "";
    const avatar = React.createElement(OperatorIcon, { size: 40, name: operatorFirstLetter });
    const responseText = getAgentResponse(response);
    return (React.createElement(React.Fragment, null,
        React.createElement(AgentCardContainer, { id: `alme-operator-live-chat-card-${responseRevision}` },
            avatar,
            React.createElement(AgentCardMessageContainer, null,
                React.createElement(AgentCardBubble, null,
                    React.createElement(AgentCardBubbleContent, null,
                        responseText,
                        paintNavUrl(entryId, response.navUrl, props.appConfig, props.onDisplayLinkClick, props.isLastResponse, props.focusProps)))))));
};
export default AlmeLiveChatOperatorResponse;
